import { createSlice } from "@reduxjs/toolkit";

const clients = [
  // Wireless
  {
    "clientId": "00:11:22:33:44:55",
    "status": "online",
    "clientName": "MacBook-Pro-16",
    "ipAddress": "192.168.1.105",
    "manufacturer": "Apple",
    "authenticationType": "WPA2-PSK",
    "connectedToDeviceName": "AP-Office-West",
    "connectedToDeviceId": "BC:22:28:25:07:38",
    "connectedToDeviceType": "ap",
    "interface": "wlan0",
    "vlan": 10,
    "ssid": "Corporate-WiFi",
    "port": null,
    "channel": 36,
    "lastSeen": 1735584000000,
    "snr": 42.5,
    "rssi": -52,
    "band": "5GHz",
    "signal": "111",
    "download": "8532342430",
    "upload": "5042340000",
    "traffic": "13574682430",
    "description": "Marketing Team",
    "isBlocked": false,
  },
  {
    "clientId": "00:11:22:33:44:66",
    "status": "online",
    "clientName": "iPhone-15-Pro",
    "ipAddress": "192.168.1.108",
    "manufacturer": "Apple",
    "authenticationType": "WPA2-PSK",
    "connectedToDeviceName": "AP-Lobby-Main",
    "connectedToDeviceId": "00:7A:82:33:44:53",
    "connectedToDeviceType": "ap",
    "interface": "wlan0",
    "vlan": 10,
    "ssid": "Corporate-WiFi",
    "port": null,
    "channel": 1,
    "lastSeen": 1734584000000,
    "snr": 38.2,
    "rssi": -58,
    "band": "2.4GHz",
    "signal": "111",
    "download": "4232342430",
    "upload": "1242340000",
    "traffic": "5474682430",
    "description": "",
    "isBlocked": false,
  },
  {
    "clientId": "00:11:22:33:44:77",
    "status": "online",
    "clientName": "Dell-XPS-15",
    "ipAddress": "192.168.1.112",
    "manufacturer": "Dell",
    "authenticationType": "WPA2-PSK",
    "connectedToDeviceName": "AP-Conf-Room-A",
    "connectedToDeviceId": "00:7A:82:55:66:77",
    "connectedToDeviceType": "ap",
    "interface": "wlan0",
    "vlan": 10,
    "ssid": "Corporate-WiFi",
    "port": null,
    "channel": 149,
    "lastSeen": 1733584000000,
    "snr": 31.5,
    "rssi": -68,
    "band": "5GHz",
    "signal": "110",
    "download": "3532342430",
    "upload": "1542340000",
    "traffic": "5074682430",
    "description": "Sales Manager",
    "isBlocked": false,
  },
  {
    "clientId": "00:11:22:33:44:88",
    "status": "online",
    "clientName": "iPad-Air",
    "ipAddress": "192.168.1.125",
    "manufacturer": "Apple",
    "authenticationType": "WPA2-PSK",
    "connectedToDeviceName": "AP-Guest-Café",
    "connectedToDeviceId": "00:7A:82:55:66:75",
    "connectedToDeviceType": "ap",
    "interface": "wlan0",
    "vlan": 20,
    "ssid": "Guest-Access",
    "port": null,
    "channel": 6,
    "lastSeen": 1732584000000,
    "snr": 25.5,
    "rssi": -72,
    "band": "2.4GHz",
    "signal": "100",
    "download": "2132342430",
    "upload": "442340000",
    "traffic": "2574682430",
    "description": "Guest Device",
    "isBlocked": false,
  },
  // Wired
  {
    "clientId": "AA:BB:CC:DD:EE:FF",
    "status": "online",
    "clientName": "Workstation-RD-01",
    "ipAddress": "192.168.10.55",
    "manufacturer": "Dell",
    "authenticationType": "802.1X",
    "connectedToDeviceName": "SW-Core-01",
    "connectedToDeviceId": "3C:33:32:14:A2:00",
    "connectedToDeviceType": "switch",
    "interface": "eth0",
    "vlan": 10,
    "ssid": null,
    "port": 5,
    "channel": null,
    "lastSeen": 1735584000000,
    "snr": null,
    "rssi": null,
    "band": null,
    "signal": null,
    "download": "15423400000",
    "upload": "8542340000",
    "traffic": "23965740000",
    "description": "Build Server",
    "isBlocked": false,
  }
]

export const clientsSlice = createSlice({
  name: "clients",
  initialState: {
    resource: "clients",
    data: clients,
    total: clients.length
  },
  reducers: {
    updateMainClients: (state, action) => {
      const index = state.data.findIndex(item => item.clientId === action.payload.clientId);
      if (index !== -1) {
        state.data[index] = { ...state.data[index], ...action.payload };
      }
    },
  },
});

export const {
  updateMainClients,
} = clientsSlice.actions;

export default clientsSlice.reducer;